import React from "react";
import ProductCard from "./ProductCard";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RecommendedOne = ({ popularProducts = [] }) => {
  const { t } = useTranslation();
  return (
    <section className="recommended  margin-100">
      <div className="container">
        <div className="section-heading flex-between flex-wrap">
          <h5 className="mb-0">{t("popularProducts")}</h5>
          <Link
            to="/products"
            class="btn btn-main-two fw-medium d-inline-flex align-items-center rounded-pill gap-8"
          >
            {t("shopNow")}
            <span class="icon text-xl d-flex">
              <i class="ph ph-arrow-right"></i>
            </span>
          </Link>
        </div>
        <div className="row g-12">
          {popularProducts.length === 0 ? (
            <div className="text-center">
              <img className="" src="/assets/images/grey.png" alt="" />
              <p className="">The data is not available for the region you are from.</p>
            </div>
          ) : (
            popularProducts.map((item) => (
              <ProductCard item={item} className="col-lg-3 col-sm-4 col-6" key={item._id} />
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default RecommendedOne;
